import { StudentProfileButtonService } from './../../services/student-profile-button.service';
import { FormValidationService } from './../../services/form-validation.service';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { StudentProfileActivitiesComponent } from './student-profile-activities/student-profile-activities.component';
import { StudentProfileExperienceComponent } from './student-profile-experience/student-profile-experience.component';
import { StudentProfilePageTwoComponent } from './student-profile-page-two/student-profile-page-two.component';
import { StudentProfileComponent } from './student-profile/student-profile.component';


@Component({
  selector: 'app-student-profile-container',
  templateUrl: './student-profile-container.component.html',
  styleUrls: ['./student-profile-container.component.scss'],
})
export class StudentProfileContainerComponent implements OnInit, OnDestroy {
  @Input() studentUserId: number;
  @Input() studentProfileId: number;
  @Input() currentStudentPartnerId: number;
  currentComponent: any;
  nextPage: string;
  prevPage: string;
  isStudenFirstLogOn = false;
  role: string;
  subscription: Subscription[] = [];
  @ViewChild('appStudentProfile') appStudentProfile: StudentProfileComponent;
  @ViewChild('appStudentPageTwo') appStudentPageTwo: StudentProfilePageTwoComponent;
  @ViewChild('appStudentProfileActivities') appStudentProfileActivities: StudentProfileActivitiesComponent;
  @ViewChild('appStudentProfileExperience') appStudentProfileExperience: StudentProfileExperienceComponent;

  private destroyed$ = new Subject();

  constructor(
    private _commonDataSharedService: CommonDataSharedService,
    private _commonAuthService: CommonAuthenticationService,
    private _router: Router,
    private _routes: ActivatedRoute,
    private _formValidationService: FormValidationService,
    public buttonService: StudentProfileButtonService
  ) {
  }

  ngOnInit() {
    this.subscription.push(
      this._commonDataSharedService.studentProfileSave.subscribe(() => {
        this.saveData();
      }),
      this._commonDataSharedService.coachStudentLoginStatus.subscribe((data) => {
        this.isStudenFirstLogOn = data['isFirstLogOn'];
      })
    );
    const loginData = this._commonAuthService.getLoginData();
    this.role = loginData.module.trim().toLowerCase();
    if (!this.studentProfileId || !this.studentUserId || this.role === 'student') {
      this.studentProfileId = +loginData.profileId;
      this.studentUserId = +loginData.userId;
    }

    this.currentComponent = 'StudentProfileComponent';
    this.nextPage = 'pageTwo';
    this.prevPage = null;

    this.buttonService.nextEmitter.pipe(takeUntil(this.destroyed$)).subscribe(() => this.onNavigate(this.nextPage, true));
    this.buttonService.prevEmitter.pipe(takeUntil(this.destroyed$)).subscribe(() => this.onNavigate(this.prevPage));
    this.buttonService.completeEmitter.pipe(takeUntil(this.destroyed$)).subscribe(() => this.completeJourney());

  }

  saveData() {
    switch (this.currentComponent) {
      case 'StudentProfileComponent':
        this._commonDataSharedService.saveEmailPhone.next()
        this.appStudentProfile.saveData();
        break;
      case 'StudentProfilePageTwoComponent':
        this.appStudentPageTwo.saveData();
        break;
      case 'StudentProfileActivitiesComponent':
        this.appStudentProfileActivities.saveData();
        break;
      case 'StudentProfileExperienceComponent':
        this.appStudentProfileExperience.saveData();
        break;
    }
  }

  navigatetoNextStep(value) {
    switch (value) {
      case 'pageTwo':
        this._commonDataSharedService.saveEmailPhone.next()
        this.prevPage = 'pageOne';
        this.nextPage = 'activities';
        this.currentComponent = 'StudentProfilePageTwoComponent';
        break;
      case 'activities':
        this.prevPage = 'pageTwo';
        this.nextPage = 'experience';
        this.currentComponent = 'StudentProfileActivitiesComponent';
        break;
      case 'experience':
        this.prevPage = 'activities';
        this.nextPage = 'home';
        this.currentComponent = 'StudentProfileExperienceComponent';
        break;
      default:
        this.prevPage = null;
        this.nextPage = 'pageTwo';
        this.currentComponent = 'StudentProfileComponent';
        break;
    }


  }

  onNavigate(value, withSave?) {

    this.buttonService.disableButtons();
    if (withSave) {
      this.saveData();
    }

    // if navigate event raised - that means buttons were enabled that means forms were valid
    // clear forms validation for old page
    this._formValidationService.clearForms();
    switch (value) {
      case 'pageTwo':
        this.prevPage = 'pageOne';
        this.nextPage = 'activities';
        this.currentComponent = 'StudentProfilePageTwoComponent';
        this._commonDataSharedService.goBackFlag.next('pageTwo');
        break;
      case 'activities':
        this.prevPage = 'pageTwo';
        this.nextPage = 'experience';
        this.currentComponent = 'StudentProfileActivitiesComponent';
        this._commonDataSharedService.goBackFlag.next('pageThree');
        break;
      case 'experience':
        this.prevPage = 'activities';
        this.nextPage = 'home';
        this.currentComponent = 'StudentProfileExperienceComponent';
        break;
      default:
        this.prevPage = null;
        this.nextPage = 'pageTwo';
        this.currentComponent = 'StudentProfileComponent';
        break;
    }


    this.buttonService.enableButtons();
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.subscription.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }

  completeJourney() {
    this.saveData();
    if (this._router.url.split('/')[1].toLowerCase() === 'student') {
      this._router.navigate(['../home'], { relativeTo: this._routes });
    } else {
      this.prevPage = null;
      this.nextPage = 'pageTwo';
      this.currentComponent = 'StudentProfileComponent';
    }
  }
}
